
const languages = [
    { name: 'English', code: 'en' },
    { name: 'Spanish', code: 'es' },
    { name: 'Polish', code: 'pl' },
    { name: 'German', code: 'de' },
    { name: 'French', code: 'fr' },
    { name: 'Italian', code: 'it' },
    { name: 'Dutch', code: 'nl' },
    { name: 'Swedish', code: 'sv' },
    { name: 'Norwegian', code: 'no' },
    { name: 'Danish', code: 'da' },
    { name: 'Finnish', code: 'fi' },
    { name: 'Portuguese', code: 'pt' }
];

export default languages;



// WEBPACK FOOTER //
// ./src/models/languages.js